import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  createSearchUrlForCustomAPI,
  GlobalVariables,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
} from '../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  showErrorMessage,
  GlobalVariables,
  API_URL,
  createSearchUrlForCustomAPI,
};
export const ROUNDINGRULEAPI = `${API_URL}/api/MasterData/SaveRoundingRule`;
export const GETROUNDINGRULE = `${API_URL}/api/MasterData/GetRoundingRulesList`;
// export const GETROUNDINGRULE = `${API_URL}/api/MasterData/GetRoundingRules`;
export const DELETEROUNDINGRULE = `${API_URL}/api/MasterData/DeleteRoundingRule`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GETROUNDINGRULEBYID = `${API_URL}/api/MasterData/GetRoundingRuleById`;
export const roundingRuleActionTypes = {
  get_masterdata: createRequestActionTypes('GET_MASTER_DATA'),
  get_rounding_rule: createRequestActionTypes('GET_ROUNDING_RULE'),
  post_rounding_rule: createRequestActionTypes('POST_ROUNDING_RULE'),
  delete_rounding_rule: createRequestActionTypes('DELETE_ROUNDING_RULE'),
  update_from_index: createRequestActionTypes('UPDATE_FROM_INDEX'),
  get_rounding_rule_byId: createRequestActionTypes('GET_ROUNDING_RULE_BYID'),
};
export const MODULE = 'MASTER_ROUNDINGRULE';



// WEBPACK FOOTER //
// ./src/modules/Masters/components/rounding-rule/constants/ApiConstants.js